export default "__VITE_ASSET__ec4b0a68__"